import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

// Throw the ball with the right power to topple the 7-stone pile.
export default function Lagori() {
  const [stones, setStones] = useState(7);
  const [throwsLeft, setThrows] = useState(3);
  const [flying, setFlying] = useState(0);
  const [phase, setPhase] = useState("ready"); // ready | aim | over
  const [power, setPower] = useState(0);
  const [msg, setMsg] = useState("Knock down all 7 stones in 3 throws!");
  const dir = useRef(1);
  const raf = useRef(null);

  const startAim = () => {
    setPhase("aim"); setPower(0); dir.current = 1;
    const tick = () => {
      setPower((p) => { let np = p + dir.current * 2.4; if (np >= 100) { np = 100; dir.current = -1; } if (np <= 0) { np = 0; dir.current = 1; } return np; });
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
  };

  const release = () => {
    if (phase !== "aim") return;
    cancelAnimationFrame(raf.current);
    const bonus = power >= 60 && power <= 92 ? 3 : 0;
    const toppled = Math.min(stones, Math.max(0, Math.round(power / 22) + bonus));
    const left = stones - toppled;
    const t = throwsLeft - 1; setThrows(t);
    const finish = () => {
      if (left === 0) { setPhase("over"); setMsg(`Lagori! All stones down 🎯`); }
      else if (t <= 0) { setPhase("over"); setMsg(`${left} stone(s) still standing`); }
      else { setPhase("ready"); setMsg(`Toppled ${toppled}! ${left} left, ${t} throw(s) to go.`); }
    };
    if (toppled > 0) {
      setPhase("throwing"); setMsg("💥 Dhadaam!"); setFlying(toppled); sfx.crash();
      setTimeout(() => { setStones(left); setFlying(0); finish(); }, 650);
    } else { setMsg("Missed! No stones down."); finish(); }
  };

  const reset = () => { setStones(7); setThrows(3); setPhase("ready"); setPower(0); setMsg("Knock down all 7 stones in 3 throws!"); };
  useEffect(() => () => cancelAnimationFrame(raf.current), []);

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Stones" value={stones} />
        <AScore label="Throws" value={throwsLeft} />
      </div>
      <p data-testid="lagori-msg" className="my-2 min-h-[1.5rem] font-signboard text-lg text-kirana-brown">{msg}</p>

      <div className="mx-auto my-3 flex h-40 w-full max-w-[220px] flex-col-reverse items-center justify-start gap-0.5" data-testid="lagori-stack">
        {Array.from({ length: stones }).map((_, i) => {
          const breaking = flying > 0 && i >= stones - flying;
          const sign = i % 2 ? 1 : -1;
          return (
            <span key={i} className={`rounded-sm border border-black/30 ${breaking ? "stone-break" : ""}`} style={{
              width: `${64 - i * 6}%`, height: "13%",
              background: ["#6b4a2f", "#8a5e38", "#a9784f", "#7a5a3a"][i % 4],
              "--tx": `${sign * (40 + i * 8)}px`, "--rot": `${sign * (60 + i * 30)}deg`,
            }} />
          );
        })}
        {stones === 0 && <span className="font-signboard text-2xl text-kirana-green">Cleared! 🎉</span>}
      </div>

      {phase === "aim" && (
        <div className="mx-auto mb-3 h-3 w-full max-w-md overflow-hidden rounded-full border-2 border-kirana-brown bg-kirana-cream">
          <div className="absolute" />
          <div className="relative h-full">
            <div className="absolute inset-y-0 bg-kirana-green/50" style={{ left: "60%", width: "32%" }} />
            <div className="h-full bg-kirana-red" style={{ width: `${power}%` }} data-testid="lagori-power" />
          </div>
        </div>
      )}

      {phase === "ready" && <ABtn data-testid="lagori-start" onClick={startAim} tone="gold" className="px-8 py-3">Aim Throw</ABtn>}
      {phase === "aim" && <ABtn data-testid="lagori-throw" onClick={release} tone="red" className="px-10 py-3 text-lg">THROW! 🎯</ABtn>}
      {phase === "over" && (
        <>
          <AResult testId="lagori-result" win={stones === 0} text={stones === 0 ? "Lagori! You Win 🎉" : "Out of throws 😅"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="lagori-again" onClick={reset} tone="green">Play Again</ABtn></div>
        </>
      )}
    </div>
  );
}
